document.addEventListener('click', function (e) {
  const btn = e.target.closest('.popup-youtube');
  if (!btn) return;

  e.preventDefault();

  const wrapper = btn.closest('.js-video');
  if (!wrapper) return;

  const videoType = wrapper.dataset.videoType;
  const videoId = wrapper.dataset.videoId;
  const videoUrl = wrapper.dataset.videoUrl;
  const loop = wrapper.dataset.loop === 'true';

  wrapper.innerHTML = '';

  if (videoType === 'youtube') {
    let src = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&mute=1&playsinline=1&controls=0&modestbranding=1`;

    if (loop) {
      src += `&loop=1&playlist=${videoId}`;
    }

    const iframe = document.createElement('iframe');
    iframe.className = 'hover-video';
    iframe.src = src;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');

    wrapper.appendChild(iframe);
  } else {
    const video = document.createElement('video');
    video.className = 'hover-video';
    video.src = videoUrl;
    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.controls = false;

    if (loop) {
      video.loop = true;
    }

    wrapper.appendChild(video);
    video.play();
  }
});